import { httpApi } from '@api/http.api.ts';

export interface HealthInfoResponse {
    version: string;
    buildTimeUTC: string;
    deployedAtUTC: string;
    maintenanceInfo: {
        plannedMaintenanceUTC: string | null;
        expectedEndOfMaintenanceUTC: string | null;
        isMaintenance: boolean;
        maintenanceMessage?: string;
    };
    minioHealth: {
        isHealthy: boolean;
        message: string;
    };
    serverTime: string;
}

export const getHealthInfo = (): Promise<HealthInfoResponse> =>
    httpApi.get<HealthInfoResponse>(`health`).then(({ data }) => data);
